import React from "react"

function MonoPill({ label, value, danger }) {
  return (
    <span
      className={`inline-flex items-center gap-1 font-mono text-[11px] px-[7px] py-[1px] rounded-pill ${
        danger ? "text-negative" : "text-ink-tertiary"
      }`}
      style={{ fontVariantNumeric: "tabular-nums" }}
    >
      <span className="text-ink-faint">{label}</span>
      <span>{value}</span>
    </span>
  )
}

export default function FrustrationPages({ t, pages }) {
  const list = pages || []
  const isEmpty = list.length === 0

  return (
    <section className="space-y-5">
      <header className="space-y-2">
        <p
          className="font-mono text-[10px] text-ink-tertiary"
          style={{ letterSpacing: "0.15em", fontVariantNumeric: "tabular-nums" }}
        >
          {t("dashboard.overview.frustration_eyebrow")}
        </p>
        <h2
          className="text-[22px] font-medium text-ink-primary"
          style={{ letterSpacing: "-0.03em" }}
        >
          {t("dashboard.overview.frustration_title")}
        </h2>
      </header>

      {isEmpty ? (
        <p className="text-[13px] text-ink-tertiary" style={{ lineHeight: 1.55 }}>
          {t("dashboard.overview.frustration_empty")}
        </p>
      ) : (
        <ul
          className="border-t border-rule-strong divide-y divide-rule"
          style={{ listStyle: "none" }}
        >
          {list.map((row) => (
            <li
              key={row.path}
              className="grid gap-3 items-baseline py-4"
              style={{ gridTemplateColumns: "minmax(0,1fr) auto" }}
            >
              <div className="min-w-0">
                <code
                  className="font-mono text-[13px] text-ink-primary truncate block"
                  style={{ fontVariantNumeric: "tabular-nums" }}
                >
                  {row.path}
                </code>
                <span
                  className="font-mono text-[11px] text-ink-tertiary"
                  style={{ fontVariantNumeric: "tabular-nums" }}
                >
                  {row.visits.toLocaleString()} {t("dashboard.overview.frustration_visits_suffix")}
                </span>
              </div>
              <div className="flex items-center gap-2 flex-wrap justify-end">
                {row.rage_click_count > 0 && (
                  <MonoPill label="RAGE" value={row.rage_click_count} danger />
                )}
                {row.dead_click_count > 0 && (
                  <MonoPill label="DEAD" value={row.dead_click_count} danger />
                )}
                {row.form_abandoned_count > 0 && (
                  <MonoPill label="FORM" value={row.form_abandoned_count} danger />
                )}
                <span
                  className="inline-flex items-center text-[13px] font-medium text-negative"
                  style={{ fontVariantNumeric: "tabular-nums" }}
                >
                  {(row.frustration_rate * 100).toFixed(1)}%
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
